(function () {
  function toNumber(value, fallback) {
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    if (typeof value === 'string') {
      const parsed = Number(value.replace(',', '.'));
      if (Number.isFinite(parsed)) return parsed;
    }
    return fallback;
  }

  function parseTiers(pricingRules) {
    if (!pricingRules) return [];

    if (typeof pricingRules === 'string') {
      try {
        return parseTiers(JSON.parse(pricingRules));
      } catch (error) {
        return [];
      }
    }

    if (Array.isArray(pricingRules)) return pricingRules;
    if (typeof pricingRules.quantity_discounts === 'string') {
      return parseTiers(pricingRules.quantity_discounts);
    }
    if (Array.isArray(pricingRules.quantity_discounts)) return pricingRules.quantity_discounts;
    if (typeof pricingRules.tiers === 'string') {
      return parseTiers(pricingRules.tiers);
    }
    if (Array.isArray(pricingRules.tiers)) return pricingRules.tiers;

    return [];
  }

  function getMultiplier(pricingRules, quantity) {
    const tiers = parseTiers(pricingRules);
    const qty = Math.max(1, Math.floor(toNumber(quantity, 1)));

    for (let index = 0; index < tiers.length; index += 1) {
      const tier = tiers[index] || {};
      const min = toNumber(tier.min ?? tier.min_qty ?? tier.quantity_min, 1);
      const max = toNumber(tier.max ?? tier.max_qty ?? tier.quantity_max, Number.POSITIVE_INFINITY);

      if (qty < min || qty > max) continue;

      if (tier.multiplier !== undefined) return toNumber(tier.multiplier, 1);
      if (tier.coefficient !== undefined) return toNumber(tier.coefficient, 1);
      if (tier.coef !== undefined) return toNumber(tier.coef, 1);
      if (tier.discount_percent !== undefined) {
        const percent = toNumber(tier.discount_percent, 0);
        return Math.max(0, 1 - percent / 100);
      }
    }

    return 1;
  }

  function calculate(params) {
    const basePriceCents = toNumber(params.basePriceCents, 0);
    const techniquePriceCents = toNumber(params.techniquePriceCents, 0);
    const zonePriceCents = toNumber(params.zonePriceCents, 0);
    const quantity = Math.max(1, Math.floor(toNumber(params.quantity, 1)));
    const multiplier = getMultiplier(params.pricingRules, quantity);

    const personalizationUnitBeforeDiscount = techniquePriceCents + zonePriceCents;
    const personalizationUnitAfterDiscount = Math.round(personalizationUnitBeforeDiscount * multiplier);
    const unitBeforeDiscount = basePriceCents + personalizationUnitBeforeDiscount;
    const unitAfterDiscount = basePriceCents + personalizationUnitAfterDiscount;
    const totalPriceCents = unitAfterDiscount * quantity;
    const totalProductPriceCents = basePriceCents * quantity;
    const totalPersonalizationBeforeDiscount = personalizationUnitBeforeDiscount * quantity;
    const totalPersonalizationPriceCents = personalizationUnitAfterDiscount * quantity;
    const totalPersonalizationDiscountCents = Math.max(0, totalPersonalizationBeforeDiscount - totalPersonalizationPriceCents);
    const personalizationDiscountPercent =
      personalizationUnitBeforeDiscount > 0
        ? Math.max(0, Math.round((1 - (personalizationUnitAfterDiscount / personalizationUnitBeforeDiscount)) * 100))
        : 0;

    return {
      quantity: quantity,
      multiplier: multiplier,
      productUnitPrice: basePriceCents,
      personalizationUnitBeforeDiscount: personalizationUnitBeforeDiscount,
      personalizationUnitAfterDiscount: personalizationUnitAfterDiscount,
      unitBeforeDiscount: unitBeforeDiscount,
      unitAfterDiscount: unitAfterDiscount,
      totalPriceCents: totalPriceCents,
      totalProductPriceCents: totalProductPriceCents,
      totalPersonalizationBeforeDiscount: totalPersonalizationBeforeDiscount,
      totalPersonalizationPriceCents: totalPersonalizationPriceCents,
      totalPersonalizationDiscountCents: totalPersonalizationDiscountCents,
      personalizationDiscountPercent: personalizationDiscountPercent
    };
  }

  function formatMoney(cents, currencyCode) {
    const amount = (toNumber(cents, 0) || 0) / 100;
    const formatter = new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: currencyCode || 'EUR'
    });
    return formatter.format(amount);
  }

  window.PersonalizerPricing = {
    calculate: calculate,
    formatMoney: formatMoney
  };
})();
